import * as tslib_1 from "tslib";
import { Type } from 'class-transformer';
import { ARInvoiceItemResultDto } from './ar-invoice-item-result-dto';
import { UpdatedResultDto } from '../../common/updated-result-dto';
import { KeyValueResultDto } from '../../../../../_models/key-value-result-dto';
import { FileInfoDisplayResultDto } from '../../../../../_models/file-info-display-result-dto';
const ɵ0 = () => Date, ɵ1 = () => Date, ɵ2 = () => Date, ɵ3 = () => UpdatedResultDto, ɵ4 = () => FileInfoDisplayResultDto, ɵ5 = () => ARInvoiceItemResultDto, ɵ6 = () => KeyValueResultDto, ɵ7 = () => Date, ɵ8 = () => Date, ɵ9 = () => FileInfoDisplayResultDto;
export class ARInvoiceResultDto {
    constructor() {
        this.allowReverse = false;
        this.allowWaive = false;
        this.allowWriteOff = false;
        this.allowDelete = false;
        this.allowEdit = false;
        /**
         * If allow Edit is false, allowBasicEdit is true, then user can only modify
         */
        this.allowBasicEdit = false;
        this.allowDuplicate = false;
        this.allowApplyCredit = false;
        this.isWrittenOff = false;
        this.isWaived = false;
        this.isReversalInvoice = false;
    }
}
tslib_1.__decorate([
    Type(ɵ0),
    tslib_1.__metadata("design:type", Date)
], ARInvoiceResultDto.prototype, "documentDate", void 0);
tslib_1.__decorate([
    Type(ɵ1),
    tslib_1.__metadata("design:type", Date)
], ARInvoiceResultDto.prototype, "postDate", void 0);
tslib_1.__decorate([
    Type(ɵ2),
    tslib_1.__metadata("design:type", Date)
], ARInvoiceResultDto.prototype, "dueDate", void 0);
tslib_1.__decorate([
    Type(ɵ3),
    tslib_1.__metadata("design:type", UpdatedResultDto)
], ARInvoiceResultDto.prototype, "lastUpdate", void 0);
tslib_1.__decorate([
    Type(ɵ4),
    tslib_1.__metadata("design:type", FileInfoDisplayResultDto)
], ARInvoiceResultDto.prototype, "supportDocument", void 0);
tslib_1.__decorate([
    Type(ɵ5),
    tslib_1.__metadata("design:type", Array)
], ARInvoiceResultDto.prototype, "items", void 0);
tslib_1.__decorate([
    Type(ɵ6),
    tslib_1.__metadata("design:type", Array)
], ARInvoiceResultDto.prototype, "requiredDimensions", void 0);
tslib_1.__decorate([
    Type(ɵ7),
    tslib_1.__metadata("design:type", Date)
], ARInvoiceResultDto.prototype, "reversedDate", void 0);
tslib_1.__decorate([
    Type(ɵ8),
    tslib_1.__metadata("design:type", Date)
], ARInvoiceResultDto.prototype, "deletedDate", void 0);
tslib_1.__decorate([
    Type(ɵ9),
    tslib_1.__metadata("design:type", Array)
], ARInvoiceResultDto.prototype, "attachments", void 0);
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9 };
